import React from 'react'
import {Tireset} from "../../../../domain-models"
import TireData from "./TireData"
import Images from "../VehicleData/Details/Images"
import {make, model} from "../../../../filters"
import Trans from '../../../../components/Trans'

type Props = {
  tiresets: Array<Tireset>
  currentTireset: Tireset
}

const OtherSubjects = ({tiresets, currentTireset}: Props) => {

  return (
    <div className={'grid gap-4'}>
      <h2 className={'font-semibold'}><Trans>Andere in dieser Auktion enthaltene Artikel</Trans>:</h2>
      <div className={'divide-y divide-gray-500 grid gap-4'}>
        {tiresets.map(tireset => {
          return tireset.Id === currentTireset.Id ? null : (
            <div key={tireset.Id} className="mt-2 grid grid-cols-1 lg:grid-cols-2 gap-2 test-gray-900">
              <div className={'col-span-2 font-semibold'}>
                <Trans>Radsatz für</Trans> {make(tireset.Make)} {model(tireset.Make, tireset.Model)}
              </div>

              <div className="w-full">
                <Images images={tireset && tireset.images && tireset.images.length ? tireset.images : []}/>
              </div>

              <div>
                <TireData tireset={tireset}/>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}


export default OtherSubjects

